import CE20CompaniesOrg from "Components/Organisms/Empresas/CE20";
import DaviviendaComponent from "Components/Organisms/Empresas/DaviviendaComponent/daviviendaComponent";
import { useEffect, useState } from "react"

const SelectComponent = () => {
    const [idBanco, setIdBanco] = useState(0);

    useEffect(() => {
       setIdBanco(parseInt(localStorage.getItem("id_registro")) || 1);
    }, []);

    console.log("idBanco component: ", idBanco, localStorage.getItem("id_registro"))
    return <>
        { idBanco === 1 ? 
            <DaviviendaComponent idBanco={idBanco} /> 
            : 
            idBanco !== 0 ? <CE20CompaniesOrg idBanco={idBanco} />
            : null }
    </>
}

export default SelectComponent;